import IssueDetail from '../components/IssueDetail';
import { useLocation } from 'react-router-dom';
import ScrollToTop from '../components/ScrollToTop';
import LogoSection from '../components/LogoSection';

function Contents({ data }) {
  const location = useLocation();
  console.log('Contents에 전달된 전체 데이터:', data);
  console.log('전달받은 ID:', location.state?.id);
  return (
    <div>
      {/* 낱개가 아니라 전체 데이터(data)를 issues라는 이름으로 전달합니다! */}
      <LogoSection />
      <IssueDetail />
      <ScrollToTop />
    </div>
  );
}

export default Contents;
